import React from "react";

import { T } from "services/lang/LanguageService";
import DatasetPieChart from "components/dashboard/charts/DatasetPieChart";
import DatasetLineChart from "components/dashboard/charts/dataset-line-chart/DatasetLineChart";
import DatasetScatterChart from "components/dashboard/charts/dataset-scatter-chart/DatasetScatterChart";
import Sankey from "components/dashboard/charts/sankey-chart/Sankey";
import DatasetTable from "components/dashboard/dataset-table/DatasetTable";
import FailingComponentTest from "components/dashboard/failing-component-test/FailingComponentTest";
import ProductTemplateTable from "components/dashboard/product-template-table/ProductTemplateTable";
import ErrorBoundary from "../../../ErrorBoundary";
import { DashboardComponentPropsBase, DashboardComponentState, IComponentTimed } from "./interfaces";
import FreeText from "./free-text/FreeText";

export const getDashboardId = (type: string, tabIndex: number, groupIndex: number, componentIndex: number) => {
    return `${type}-${tabIndex}-${groupIndex}-${componentIndex}`
}

export const DashboardComponentMappingWrapper = (
    props: {
        id: string,
        component: string,
        config: any ,
        referenceTime: string,
        stateCb?: (state: DashboardComponentState) => void
    }
) => {
    const config: any = {
        ...props.config,
        id: props.id,
        referenceTime: props.referenceTime,
        stateCb: props.stateCb,
        reportMode: true
    } as IComponentTimed | DashboardComponentPropsBase;

    let el: JSX.Element
    // TODO: this switch should not be here, should be possible to replace with component mapping
    switch (props.component) {
        case "DatasetLineChart":
            el =  <DatasetLineChart {...config} />;
            break;
        case "DatasetScatterChart":
            el = <DatasetScatterChart {...config} />;
            break;
        case "DatasetSankeyChart":
            el = <Sankey {...config} />;
            break;
        case "ProductTemplateTable":
            el = <ProductTemplateTable {...config} />;
            break;
        case "FreeText":
            el = <FreeText {...config} />;
            break;
        case "DatasetTable":
            el = <DatasetTable {...config} />;
            break;
        case "DatasetPieChart":
            el = <DatasetPieChart {...config} />;
            break;
        case "FailingComponentTest":
            el = <FailingComponentTest {...config} />;
            break;
        default:
            el = <div>{T("error.invalid-unknown-component")}: {props.component}</div>
    }

    const onCrash = (msg: string) => {
        if(props.stateCb) {
            props.stateCb({id: props.id, state: "error", error: msg})
        }

    }

    return <ErrorBoundary onError={onCrash}>
        {el}
    </ErrorBoundary>
}